import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = [{
    question: 'What is an ITIN and why do I need one as a foreign entrepreneur?',
    answer: 'An ITIN (Individual Taxpayer Identification Number) is a tax processing number issued by the IRS for individuals who need to file U.S. tax returns but are not eligible for a Social Security Number. As a foreign entrepreneur doing business with the U.S., you need an ITIN to comply with tax regulations, open business bank accounts, form LLCs, receive payments from U.S. clients, and claim tax treaty benefits.'
  }, {
    question: 'How long does it take to get an ITIN?',
    answer: 'With our expedited service, most applicants receive their ITIN within 6-8 weeks. This is significantly faster than applying directly with the IRS, which can take 3-4 months or longer, especially during tax season.'
  }, {
    question: 'Do I need to mail my original identification documents?',
    answer: 'No! This is one of the key benefits of our service. As IRS-certified acceptance agents, we can certify your identification documents, meaning you only need to provide digital copies. Your original passport and documents stay safely with you.'
  }, {
    question: 'What documents do I need to apply for an ITIN?',
    answer: "You'll need a valid passport or other government-issued ID, proof of foreign status, and documentation supporting your need for an ITIN (such as business formation documents or contracts with U.S. clients). Our system will guide you through exactly what you need based on your specific situation."
  }, {
    question: 'Can I use my ITIN to open a U.S. bank account?',
    answer: 'Yes, many U.S. financial institutions accept ITINs for opening business bank accounts for non-residents. Your ITIN serves as your tax identification number for banking purposes, though banks may have additional requirements.'
  }, {
    question: 'How do I apply the discount code?',
    answer: "During the checkout process on TheITIN.com, you'll see a field labeled 'Discount Code' or 'Coupon Code'. Simply enter 'Super Neil' and click 'Apply' to receive your $50 discount on our ITIN application service."
  }];
  return <section id="faq" className="py-16 md:py-24 bg-white" data-id="element-44">
      <div className="container mx-auto px-4" data-id="element-45">
        <div className="text-center mb-16" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-47">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-48">
            Everything you need to know about getting your ITIN as a foreign
            entrepreneur.
          </p>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-49">
          {faqs.map((faq, index) => <div key={index} className="border-b border-gray-200 py-5" data-id="element-50">
              <button className="flex justify-between items-center w-full text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-51">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-52">
                  {faq.question}
                </h3>
                {openIndex === index ? <ChevronUpIcon className="text-blue-600 flex-shrink-0" size={20} data-id="element-53" /> : <ChevronDownIcon className="text-gray-600 flex-shrink-0" size={20} data-id="element-54" />}
              </button>
              {openIndex === index && <div className="mt-3 text-gray-600" data-id="element-55">
                  <p data-id="element-56">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-57">
          <p className="text-gray-600 mb-6" data-id="element-58">
            Still have questions? Visit our partner site for more information.
          </p>
          <a href="https://theitin.com/ref/598/" target="_blank" rel="noopener noreferrer" className="bg-white hover:bg-gray-100 text-blue-600 border border-blue-600 px-8 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-59">
            Learn More
          </a>
        </div>
      </div>
    </section>;
}